const HOST = process.env.VUE_APP_BACKEND_HOST;
const BASE = `${HOST}/api`;

const endpoints = {
  auth: {
    login: () => `${BASE}/login`,
    happygastLogin: () => `${BASE}/happygast-login`,
    register: () => `${BASE}/register`,
    forgotPassword: () => `${BASE}/forgot-password`,
    resetPassword: () => `${BASE}/reset-password`,
    logout: () => `${BASE}/logout`,
  },

  profile: {
    base: () => `${BASE}/profile`,
    update: () => endpoints.profile.base(),
    updatePassword: () => `${endpoints.profile.base()}/password`,
    updateLocale: () => `${endpoints.profile.base()}/locale`,
    toggleFavoriteFirm: (firmId) => `${endpoints.profile.base()}/firms/${firmId}/toggle-favorite`,
  },

  users: {
    base: () => `${BASE}/users`,
    item: (id) => `${endpoints.users.base()}/${id}`,
    updatePassword: (id) => `${endpoints.users.item(id)}/password`,
  },

  companyUsers: {
    base: (firmId) => `${BASE}/firms/${firmId}/users`,
    item: (firmId, userId) => `${endpoints.companyUsers.base(firmId)}/${userId}`,
    emailStatus: (firmId) => `${endpoints.companyUsers.base(firmId)}/email-status`,
    departmentResponsibles: (firmId) => `${BASE}/firms/${firmId}/departments/responsibles`,
    updateDepartmentResponsibles: (firmId, departmentId) =>
      `${BASE}/firms/${firmId}/departments/${departmentId}/responsibles`,
  },

  unitCodes: {
    base: () => `${BASE}/unit-code`,
    list: () => `${endpoints.unitCodes.base()}/list`,
  },

  firms: {
    base: () => `${BASE}/firms`,
    list: () => `${endpoints.firms.base()}/list`,
    item: (id) => `${endpoints.firms.base()}/${id}`,
    showByHappyGastId: (id) => `${endpoints.firms.base()}/show/${id}`,
    uploadLogo: () => `${endpoints.firms.base()}/images/upload`,
    relatedFirms: (firmId) => `${endpoints.firms.base()}/${firmId}/related-firms`,
    relatedSuppliers: (firmId) => `${endpoints.firms.base()}/${firmId}/related-suppliers`,
    users: (firmId) => `${endpoints.firms.base()}/users/${firmId}`,
    productList: (id, relatedFirmId) => `${endpoints.firms.base()}/${id}/product-list/${relatedFirmId || ''}`,
    listProductPool: (firmId) => `${endpoints.firms.base()}/${firmId}/list-product-pool`,
    featureList: (countryId) => `${BASE}/firm-feature/${countryId}/list`,
  },

  // Supplier management
  suppliers: {
    base: () => `${BASE}/suppliers`,
    list: () => `${BASE}/suppliers`,
    products: (supplierId) => `${BASE}/suppliers/${supplierId}/products`,
  },

  // Company (currently only using for restaurant) delivery and billing addresses management
  firmAddresses: {
    base: () => `${BASE}/firm-addresses`,
    store: () => `${endpoints.firmAddresses.base()}`,
    update: (id) => `${endpoints.firmAddresses.base()}/${id}`,
    getByFirm: () => `${endpoints.firmAddresses.base()}/get-by-firm`,
  },

  // Product Groups (Super Admin - global groups, no firm_id needed)
  productGroups: {
    base: () => `${BASE}/pgroups`,
    list: () => `${BASE}/pgroups/list`,
    tree: () => `${BASE}/pgroups/tree`,
    global: () => `${BASE}/pgroups/global`,
    item: (id) => `${BASE}/pgroups/${id}`,
    children: (id) => `${BASE}/pgroups/${id}/children`,
    store: () => `${BASE}/pgroups`,
    update: (id) => `${BASE}/pgroups/${id}`,
    delete: (id) => `${BASE}/pgroups/${id}`,
    assignProducts: (id) => `${BASE}/pgroups/${id}/assign-products`,
    storeNewPosition: () => `${BASE}/pgroups/store-new-position`,
    reposition: () => `${BASE}/pgroups/reposition`,
    uploadImage: () => `${BASE}/pgroups/images/upload`,
  },

  happyGast: {
    syncFirmFromHappyGast: (firmId) => `${BASE}/happy-gast/firms/${firmId}/sync-from-happygast`,
  },

  healthChecks: {
    base: () => `${BASE}/health-checks`,
    checks: () => `${endpoints.healthChecks.base()}/checks`,
    item: (issueId) => `${endpoints.healthChecks.base()}/${issueId}`,
  },
};

export default endpoints;
